module.exports = __webpack_public_path__ + "img/logo_dark.5c4497fa.png";